<template>
  <v-container>
    <v-bottom-navigation fixed class="custom-bottom-nav">
      <v-row justify="space-between" align="center" class="px-2">
        <span class="font-weight-bold text-subtitle-1 text-dark">{{ selectedDocuments.length }} Document(s) selected</span>
        <div class="d-flex">
          <button type="button" class="mr-2 btn btn-sm btn-outline-primary" @click="clearSelection" :disabled="isDownloading">Cancel</button>
          <button type="button" class="mr-2 btn btn-sm btn-primary" @click="downloadSelected" :disabled="isDownloading">
            {{ isDownloading ? 'Downloading...' : `Download (${selectedDocuments.length})` }}
          </button>
        </div>
      </v-row>
    </v-bottom-navigation>
  </v-container>
</template>

<script>

export default {
  props: ["selectedDocuments"],
  data() {
    return {
      isDownloading: false
    };
  },
  methods: {
    clearSelection() {
      this.$emit("clear-selection");
    },
    async downloadSelected() {
      this.isDownloading = true;
      try {
        await this.$store.dispatch('downloadDocument', { ids: this.selectedDocuments });
        this.clearSelection();
      } finally {
        this.isDownloading = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-bottom-nav {
  width: 100%;
  height: auto !important;
  max-width: 1185px;
  margin: 0 auto;
  padding: 16px 24px;
  background-color: #edf4fe !important;
  border-radius: 4px;
  color: white;
  right: -80px !important;
  bottom: 32px !important;
  box-shadow: 0px 3px 4px 0px #00000026 !important;
  z-index: 999 !important;
}

@media (max-width: 1440px) {
  .custom-bottom-nav {
    max-width: 80%;
  }
}
</style>
